import Cookies from 'js-cookie';
import { getLanguage } from '@/lang/index';
var state = {
  sidebar: {
    // Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  language: getLanguage(),
  sidebarType: false,
  // 默认是有二级分类
  parentMenuId: '' || window.sessionStorage.getItem('parentMenuId'),
  sidebarParentCur: null || JSON.parse(localStorage.getItem('sidebarParentCur')),
  // 父级下标
  defaultOpen: [],
  // 默认展开的菜单
  isClickTab: false,
  // 是否顶部导航点击
  menuTabData: JSON.parse(localStorage.getItem('menuTabData')) || {},
  keyWord: '',
  crudList: [] // 表单数据
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
      // localStorage.setItem('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0);
      // localStorage.setItem('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set('sidebarStatus', 0);
    // localStorage.setItem('sidebarStatus', 0)

    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  // 添加导航展开
  OPEN_SIDEBAR: function OPEN_SIDEBAR(state) {
    // localStorage.setItem('sidebarStatus', 1)
    Cookies.set('sidebarStatus', 1);
    state.sidebar.opened = true;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_LANGUAGE: function SET_LANGUAGE(state, language) {
    state.language = language;
    Cookies.set('language', language);
  },
  SET_BARTYPE: function SET_BARTYPE(state, data) {
    state.sidebarType = data;
  },
  SETPID: function SETPID(state, id) {
    state.parentMenuId = id;
    window.sessionStorage.setItem('parentMenuId', id);
  },
  SET_PARENTCUR: function SET_PARENTCUR(state, index) {
    state.sidebarParentCur = index;
    localStorage.setItem('sidebarParentCur', JSON.stringify(index));
  },
  SET_DEFAULTOPEN: function SET_DEFAULTOPEN(state, obj) {
    state.defaultOpen.push(obj);
  },
  SET_CLICK_TAB: function SET_CLICK_TAB(state, status) {
    state.isClickTab = status;
  },
  SET_CLICK_KEY: function SET_CLICK_KEY(state, status) {
    state.keyWord = status;
  },
  SET__MENU_TAB_DATA: function SET__MENU_TAB_DATA(state, menuTabData) {
    state.menuTabData = menuTabData;
    localStorage.setItem('menuTabData', JSON.stringify(menuTabData));
  },
  SET_FORM_LIST_DATA: function SET_FORM_LIST_DATA(state, crudList) {
    state.crudList = crudList;
  },
  SET_FORM_INDEX_SET: function SET_FORM_INDEX_SET(state, data) {
    // state.crudList[data.pidx].field.splice(data.i, 0, data)
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref2, _ref3) {
    var commit = _ref2.commit;
    var withoutAnimation = _ref3.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  openSideBar: function openSideBar(_ref4) {
    var commit = _ref4.commit;
    commit('OPEN_SIDEBAR');
  },
  toggleDevice: function toggleDevice(_ref5, device) {
    var commit = _ref5.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setSize: function setSize(_ref6, size) {
    var commit = _ref6.commit;
    commit('SET_SIZE', size);
  },
  setLanguage: function setLanguage(_ref7, language) {
    var commit = _ref7.commit;
    commit('SET_LANGUAGE', language);
  },
  setFormList: function setFormList(_ref8, crudList) {
    var commit = _ref8.commit;
    commit('SET_FORM_LIST_DATA', crudList);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};